const normaliseCode = code =>
  code.replace(/^((  )+)/gm, (_, p1) => "\t".repeat(p1.length / 2));

export default normaliseCode;



// WEBPACK FOOTER //
// ./src/utils/normaliseCode.js